export const getPositions = (elements, offset=true, useBounds) => {
    let lefts = [];
    let tops = [];
    let widths = [];
    let heights = [];
    for (let id in elements.current) {
        if (!elements.current[id]) {
            continue;
        }
        let _element = elements.current[id].current;
        if (!_element) {
            continue;
        }
        if (false) {
            let rect = _element.getBoundingClientRect();
            lefts.push(rect.left + (offset ? _element.offsetWidth : 0));
            tops.push(rect.top + (offset ? _element.offsetHeight : 0));
        } else {
            lefts.push(_element.offsetLeft + (offset ? _element.offsetWidth : 0));
            tops.push(_element.offsetTop + (offset ? _element.offsetHeight : 0));
        }
        heights.push(_element.offsetHeight);
        widths.push(_element.offsetWidth);
    }
    return {lefts,tops, widths, heights};
};

export const doesElementIntersect = (x, y, width, height, positions) => {
    let {lefts, tops, widths, heights} = positions;
    for (let i in lefts) {
        let _width = widths[i];
        let _height = heights[i];
        let _left = lefts[i] - _width;
        let _top = tops[i] - _height;
        if (x >= _left && x <= _left + _width &&
            y >= _top && y <= _top + _height) {
            return true;
        }
    }
    return false;
};


export const getMaxLeftAndTop= (elements) => {
    let {lefts,tops} = getPositions(elements, true, true);
    let maxLeft = Math.max(... lefts);
    let maxTop = Math.max(... tops);
    return {maxLeft, maxTop};
};

export const getMinLeftAndTop= (elements) => {
    let {lefts,tops} = getPositions(elements, false, true);
    let minLeft = Math.min(... lefts);
    let minTop = Math.min(... tops);
    return {minLeft, minTop};
};

